import * as React from "react";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    margin: theme.spacing(0),
    overflowY: 'scroll',
    zIndex: 1,
    '& thead th': {
      position: 'sticky',
      zIndex: 98,
      left: 0,
      top: 0,
      textAlign: 'left',
      verticalAlign: 'middle',
      fontWeight: 600,
      background: 'orange',
      color: theme.palette.primary.contrastText,
      padding: theme.spacing(0.75,0.5),
    },
    '& thead>tr:nth-child(2) th': {
      zIndex: 99,
      top: 25,
    },
    '& thead tr.topRow th': {
      background: '#fff',
      textAlign: 'center',
      color: '#666',
    },
    '& tfoot': {
      position: 'sticky',
      zIndex: 4,
      left: 0,
      right: 8,
      bottom: 0,
    },
    '& tfoot th': {
      position: 'sticky',
      left: 0,
      right: 8,
      bottom: 0,
      background: '#eee',
      fontSize: '0.75rem',
      zIndex: 4,
      padding: theme.spacing(1, 0, 1, 0.5),
      '& span': {
        color: '#333',
      },
    },
    '& table': {
      borderSpacing: 0,
      borderCollapse: 'collapse',
      width: '100%',
      tableLayout: 'fixed',
      '& td ': {
        textAlign: 'left',
        verticalAlign: 'middle',
        padding: theme.spacing(0.50, 0.5, 0.50, 0.5),
      },
      '& tr:hover td': {
        background: '#deebdd',
      },
    },
    '& th:last-child': {
      paddingRight: 18,
    },
    '& td:last-child': {
      paddingRight: 18,
    },
    '& th.last': {
      paddingRight: theme.spacing(1.5),
    },
    '& th.percent': {
      paddingRight: theme.spacing(0.75),
    },
    '& .right': {
      textAlign:'right',
    },
    '& .center': {
      textAlign:'center',
    },
    '& .number': {
      width:48,
      textAlign:'right',
      cursor: 'pointer',
    },
    '& .xl': {
      width:58,
    },
    '& .xxl': {
      width:73,
    },
  },
  border: {
    borderBottom: '1px solid #666',
  },
}));

interface Props {
  children: React.ReactNode;
  height?: number;
  border?: boolean;
  layout?: string;
}

export const Table: React.FC<Props> = (props:Props) => {
  const  {border, height, children, layout} = props;
  const classes = useStyles();
  const getDivStyle = React.useMemo(()=>
    border ? `${classes.root} ${classes.border}`:classes.root
  ,[border, classes]);

  const getHeight = ():{}=> {
    if (typeof height !== 'undefined') {
      if (height === 0) {
        return {};
      } else {
        return {height: height};
      }
    }
    return {height: 512};
  }

  return (
    <div className={getDivStyle} style={getHeight()}>
      <table style={{tableLayout:layout?"auto":"fixed"}}>
        {children}
      </table>
    </div>
  )
};
